import React from 'react'
/*
import twitter from '../../../assets/Icons/twitterLogo.svg'
import facebook from '../../../assets/Icons/facebookLogo.svg'
import instagram from '../../../assets/Icons/instagramLogo.svg'
import wifi from '../../../assets/Icons/wifiIcon.svg'
*/
import ecbrLogoWhite from '../../../assets/Icons/ecbrLogoWhite.svg'

import * as S from './styles'
import { Typography } from '../../../components'

const Footer = () => {
  return (
    <S.Footer>
      <img src={ecbrLogoWhite} alt="ecbrDna" />
      <Typography
        as="a"
        type="h5"
        href="https://www.ecommercebrasil.com.br/"
        target="_blank"
        rel="noreferrer"
        color="#fff"
        spacing="32px 0 0 0"
      >
        by E-Commerce Brasil
      </Typography>
      {/* <S.SocialMedia>
        <img src={twitter} alt="twitter" />
        <img src={facebook} alt="facebook" />
        <img src={wifi} alt="logo" />
        <img src={instagram} alt="instagram" />
  </S.SocialMedia> */}
    </S.Footer>
  )
}

export default Footer
